import type { Ref } from 'vue'

/**
 * SEO-мета контентной ленты (новости, блог — CMS MR 7/10): bare-title
 * (суффикс — titleTemplate seoRoot), «— страница N» на пагинированных
 * страницах — та же логика уникальности, что в useCategorySeo; активный
 * тег-фильтр включается в title/description («Блог — тег «x»»)
 */
export const useContentListSeo = (options: {
  /** Название ленты для title ('Новости', 'Блог') */
  feedTitle: string
  /** База description без точки ('Новости и события', 'Статьи блога') */
  descriptionBase: string
  /** Активный тег-фильтр ленты (`?tag=`) */
  tag?: Ref<string | undefined>
}) => {
  const siteName = useSiteName()
  const { page } = useListingPagination()

  const baseTitle = () =>
    options.tag?.value
      ? `${options.feedTitle} — тег «${options.tag.value}»`
      : options.feedTitle

  const pageTitle = () =>
    page.value > 1 ? `${baseTitle()} — страница ${page.value}` : baseTitle()

  const pageDescription = () => {
    const tagSuffix = options.tag?.value ? ` Тег «${options.tag.value}».` : ''
    const base = `${options.descriptionBase} ${siteName.value}.${tagSuffix}`
    return page.value > 1 ? `${base} Страница ${page.value}.` : base
  }

  useSeoMeta({
    title: pageTitle,
    description: pageDescription,
    ogTitle: pageTitle,
    ogDescription: pageDescription,
  })
}
